'use client';

import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';
import Footer from "./components/Footer";
import { CartProvider } from "react-use-cart";

type Props = {
  children: ReactNode;
  navbarItems: ReactNode;
};

export default function NavbarToggle({ children, navbarItems  }: Props) {
  const pathname = usePathname();
  const hideNavbar = pathname.startsWith('/admin');

  return (
    <>
      <CartProvider>
        <div className="flex flex-col min-h-screen">
          {!hideNavbar && navbarItems}
          <main className="flex-1">
            {children}
          </main>
          {!hideNavbar && <Footer />}
        </div>
      </CartProvider>
    </>
  );
}